import { LogoSmall } from "../LogoSmall";
import { BigMenu } from "./BigMenu";
import { SmallMenu } from "./SmallMenu";
import oovalLogo from "../../images/OOVAL - sB.png";

export const Navbar = ({ userData, handleSnackbar }) => {
  return (
    <>
      <div className="navbar-wrapper">
        <img
          className="big-menu-client-logo "
          src={userData?.logo || oovalLogo}
        />
        <BigMenu handleSnackbar={handleSnackbar} />
        <SmallMenu />
        <LogoSmall />
      </div>
    </>
  );
};
